import { Component } from "vue-property-decorator";

// Thanks to the link below for  vuelidate fix
//https://github.com/vuelidate/vuelidate/issues/175#issuecomment-511535505
Component.registerHooks(["validations"]);
